import React from "react"
import PropTypes from "prop-types"
import Markdown from "@components/Markdown"
const CardWithIconTextDescriptionTwo = ({
  title,
  description,
  icon,
  figureClassname = "h-full",
}) => (
  <div className="flex flex-col items-center md:items-start gap-4  xl:gap-[24px]">
    <figure className="h-20 xl:h-[100px]">
      <img className={figureClassname} src={icon} alt="alt" />
    </figure>
    <div>
      <h3
        className="text-dblue font-inter 
      text-14 xl:text-20 font-semibold 
      leading-normal uppercase mb-2  xl:mb-[12px]"
      >
        {title}
      </h3>
      <p
        className="text-bcoral font-inter 
      text-14 xl:text-20 font-normal leading-140%"
      >
        <Markdown>{description}</Markdown>
      </p>
    </div>
  </div>
)

CardWithIconTextDescriptionTwo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  figureClassname: PropTypes.string,
}

export default CardWithIconTextDescriptionTwo
